import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    status: null
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getAllMasterData({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.auditTrail
        .getAllMasterData(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    detailMasterData({ commit }, id) {
      commit(mutations.LOADING);
      return api.auditTrail
        .detailMasterData(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getAllUserManagement({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.auditTrail
        .getAllUserManagement(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    detailUserManagement({ commit }, id) {
      commit(mutations.LOADING);
      return api.auditTrail
        .detailUserManagement(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getLockBudget({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.auditTrail
        .getLockBudget(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getHierarchy({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.auditTrail
        .getHierarchy(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getGroup({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.auditTrail
        .getGroup(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getLogin({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.auditTrail
        .getLogin(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    }
  },
  getters: {}
};
